import { cargoIsDischarged } from '../../../utils/shipChanges.js';

/**
 * Known port coordinates (public geography). Used only when a stop has no lat/lng.
 *
 */
const PORT_COORDS = [
  ['CALLAO', -12.048, -77.143],
  ['HOUSTON', 29.737, -95.271],
  ['GULFPORT', 30.360, -89.093],
  ['MIAMI', 25.778, -80.179],
  ['EVERGLADES', 26.094, -80.123],
  ['JACKSONVILLE', 30.396, -81.558],
  ['SAVANNAH', 32.083, -81.099],
  ['CHARLESTON', 32.783, -79.924],
  ['WILMINGTON', 34.228, -77.947],
  ['NORFOLK', 36.907, -76.328],
  ['BALTIMORE', 39.265, -76.578],
  ['PHILADELPHIA', 39.933, -75.142],
  ['NEW YORK', 40.685, -74.074],
  ['NEWARK', 40.690, -74.175],
  ['BOSTON', 42.352, -71.043],
  ['OXNARD', 34.198, -119.177],
  ['HUENEME', 34.148, -119.195],
  ['LONG BEACH', 33.754, -118.217],
  ['LOS ANGELES', 33.740, -118.265],
  ['OAKLAND', 37.795, -122.279],
  ['SEATTLE', 47.589, -122.359],
  ['TACOMA', 47.266, -122.413],
  ['SAN DIEGO', 32.685, -117.161],
  ['SAN FRANCISCO', 37.796, -122.392],
  // Chile load ports (FruitOnline)
  ['VALPARAISO', -33.03, -71.63],
  ['SAN ANTONIO', -33.59, -71.62],
  ['SAN VICENTE', -36.73, -73.13],
  ['CORONEL', -37.03, -73.15],
  ['COQUIMBO', -29.95, -71.34],
  ['LIRQUEN', -36.71, -72.98],
  // Chile discharge ports beyond the US lanes
  ['TORONTO', 43.64, -79.37],
  ['VANCOUVER', 49.29, -123.11],
  ['SAINT JOHN', 45.27, -66.06],
  ['MONTREAL', 45.50, -73.56],
  ['ELIZABETH', 40.66, -74.19],
  ['ST PETERSBURG', 59.93, 30.30],
  ['KLAIPEDA', 55.70, 21.13],
  ['TALLINN', 59.44, 24.75],
  ['DURRES', 41.31, 19.45],
  ['KOPER', 45.55, 13.73],
  ['CONSTANTA', 44.17, 28.65],
  ['ODESSA', 46.48, 30.73],
  // --- Worldwide lanes. Cargo is no longer West-Coast-South-America -> US
  // only, and a name missing here costs the stop pin entirely while silently
  // disabling the wrong-direction guard in splitAroundPin. Every English name
  // portNames.js can produce for a seaport must appear here.
  // US East / Gulf
  ['NEW ORLEANS', 29.937, -90.063],
  ['MOBILE', 30.694, -88.040],
  ['TAMPA', 27.915, -82.450],
  ['PORT MANATEE', 27.638, -82.562],
  // Inland FL, railed from Tampa; coord taken from the last sea-leg endpoint
  // on live shipments rather than from the town itself.
  ['WINTER HAVEN', 27.886, -82.452],
  // Gloucester City NJ on the Delaware (NOT Gloucester MA) — same source.
  ['GLOUCESTER', 39.851, -75.315],
  ['BROOKLYN', 40.709, -74.024],
  // US West
  ['PORT HUENEME', 34.148, -119.195],
  ['SAN PEDRO', 33.735, -118.273],
  ['PORTLAND', 45.639, -122.763],
  // Canada
  ['PRINCE RUPERT', 54.317, -130.320],
  ['HALIFAX', 44.648, -63.573],
  // Mexico / Central America / Caribbean
  ['VERACRUZ', 19.203, -96.133],
  ['ALTAMIRA', 22.500, -97.867],
  ['LAZARO CARDENAS', 17.957, -102.174],
  ['ENSENADA', 31.850, -116.625],
  ['PROGRESO', 21.300, -89.667],
  ['QUETZAL', 13.924, -90.786],
  ['SANTO TOMAS DE CASTILLA', 15.700, -88.617],
  ['PUERTO BARRIOS', 15.731, -88.595],
  ['CORINTO', 12.483, -87.173],
  ['ACAJUTLA', 13.573, -89.835],
  ['PUERTO LIMON', 10.000, -83.033],
  ['MOIN', 10.003, -83.082],
  ['BALBOA', 8.950, -79.566],
  ['COLON', 9.364, -79.900],
  ['CRISTOBAL', 9.350, -79.908],
  ['KINGSTON', 17.973, -76.793],
  ['CAUCEDO', 18.424, -69.628],
  ['PORT OF SPAIN', 10.650, -61.517],
  // South America: Pacific
  ['PAITA', -5.085, -81.114],
  ['PISCO', -13.800, -76.283],
  ['SALAVERRY', -8.223, -78.983],
  ['MATARANI', -17.000, -72.106],
  ['ILO', -17.643, -71.345],
  ['GUAYAQUIL', -2.270, -79.900],
  ['POSORJA', -2.708, -80.247],
  ['BUENAVENTURA', 3.886, -77.070],
  ['IQUIQUE', -20.203, -70.150],
  ['ANTOFAGASTA', -23.651, -70.398],
  ['ARICA', -18.476, -70.323],
  // South America: Atlantic
  ['CARTAGENA', 10.400, -75.515],
  ['SANTA MARTA', 11.248, -74.215],
  ['BARRANQUILLA', 10.990, -74.780],
  ['SANTOS', -23.955, -46.333],
  ['PARANAGUA', -25.502, -48.512],
  ['ITAJAI', -26.906, -48.656],
  ['NAVEGANTES', -26.890, -48.654],
  ['RIO GRANDE', -32.035, -52.098],
  ['SUAPE', -8.394, -34.966],
  ['SALVADOR', -12.967, -38.512],
  ['RIO DE JANEIRO', -22.893, -43.188],
  ['ITAGUAI', -22.878, -43.826],
  ['VITORIA', -20.320, -40.337],
  ['BUENOS AIRES', -34.577, -58.372],
  ['ZARATE', -34.098, -59.028],
  ['MONTEVIDEO', -34.900, -56.212],
  // Europe: North Sea / Atlantic / Baltic
  ['ROTTERDAM', 51.950, 4.142],
  ['VLISSINGEN', 51.444, 3.580],
  ['ANTWERP', 51.280, 4.333],
  ['HAMBURG', 53.541, 9.935],
  ['BREMERHAVEN', 53.577, 8.566],
  ['BREMEN', 53.110, 8.740],
  ['DUNKIRK', 51.035, 2.370],
  ['LE HAVRE', 49.483, 0.117],
  ['BORDEAUX', 44.863, -0.552],
  ['LONDON GATEWAY', 51.512, 0.483],
  ['LONDON', 51.505, 0.070],
  ['FELIXSTOWE', 51.956, 1.321],
  ['SOUTHAMPTON', 50.895, -1.410],
  ['DUBLIN', 53.349, -6.218],
  ['GDANSK', 54.398, 18.675],
  ['GOTHENBURG', 57.690, 11.845],
  ['AARHUS', 56.153, 10.223],
  ['COPENHAGEN', 55.700, 12.600],
  ['KALININGRAD', 54.700, 20.483],
  // Europe: Iberia / Mediterranean / Black Sea
  ['ALGECIRAS', 36.133, -5.442],
  ['VALENCIA', 39.443, -0.317],
  ['BARCELONA', 41.350, 2.167],
  ['BILBAO', 43.350, -3.033],
  ['SINES', 37.950, -8.880],
  ['LISBON', 38.700, -9.170],
  ['LEIXOES', 41.185, -8.700],
  ['MARSEILLE', 43.340, 5.337],
  ['GENOA', 44.405, 8.918],
  ['LA SPEZIA', 44.095, 9.838],
  ['LIVORNO', 43.552, 10.300],
  ['VADO', 44.267, 8.433],
  ['GIOIA TAURO', 38.450, 15.900],
  ['NAPLES', 40.840, 14.263],
  ['SALERNO', 40.675, 14.750],
  ['VENICE', 45.440, 12.258],
  ['TRIESTE', 45.645, 13.760],
  ['RIJEKA', 45.327, 14.443],
  ['MARSAXLOKK', 35.830, 14.540],
  ['PIRAEUS', 37.942, 23.646],
  ['THESSALONIKI', 40.635, 22.934],
  ['AMBARLI', 40.967, 28.683],
  ['ISTANBUL', 41.010, 28.978],
  ['IZMIR', 38.433, 27.133],
  ['MERSIN', 36.800, 34.633],
  ['NOVOROSSIYSK', 44.717, 37.783],
  // Middle East
  ['JEDDAH', 21.483, 39.167],
  ['KING ABDULLAH', 22.470, 39.100],
  ['DAMMAM', 26.500, 50.200],
  ['JEBEL ALI', 25.012, 55.062],
  ['DUBAI', 25.272, 55.300],
  ['KHALIFA', 24.808, 54.645],
  ['ABU DHABI', 24.808, 54.645],
  ['SOHAR', 24.500, 56.617],
  ['SALALAH', 16.950, 54.008],
  ['HAMAD', 25.033, 51.600],
  ['AQABA', 29.517, 35.000],
  ['HAIFA', 32.833, 35.000],
  ['ASHDOD', 31.817, 34.650],
  // Africa
  ['ALEXANDRIA', 31.200, 29.867],
  ['PORT SAID', 31.267, 32.300],
  ['DAMIETTA', 31.467, 31.817],
  ['SOKHNA', 29.667, 32.350],
  ['TANGIER', 35.885, -5.500],
  ['CASABLANCA', 33.600, -7.617],
  ['DAKAR', 14.683, -17.433],
  ['ABIDJAN', 5.283, -4.017],
  ['TEMA', 5.633, 0.017],
  ['APAPA', 6.450, 3.367],
  ['LAGOS', 6.450, 3.367],
  ['POINTE NOIRE', -4.783, 11.833],
  ['WALVIS BAY', -22.950, 14.500],
  ['CAPE TOWN', -33.908, 18.433],
  ['NGQURA', -33.800, 25.683],
  // South Africa. Distinct from the bare ELIZABETH above (Elizabeth NJ) —
  // exact match runs before containment, so both keep their own coast.
  ['PORT ELIZABETH', -33.967, 25.633],
  ['DURBAN', -29.867, 31.033],
  ['MOMBASA', -4.067, 39.650],
  ['DAR ES SALAAM', -6.817, 39.300],
  // Asia: South
  ['KARACHI', 24.833, 66.983],
  ['QASIM', 24.800, 67.333],
  ['MUNDRA', 22.839, 69.722],
  ['NHAVA SHEVA', 18.950, 72.950],
  ['MUMBAI', 18.950, 72.833],
  ['COCHIN', 9.967, 76.267],
  ['TUTICORIN', 8.750, 78.200],
  ['CHENNAI', 13.100, 80.300],
  ['KOLKATA', 22.545, 88.315],
  ['COLOMBO', 6.950, 79.850],
  ['CHITTAGONG', 22.317, 91.800],
  // Asia: Southeast
  ['SINGAPORE', 1.264, 103.822],
  ['PORT KLANG', 3.000, 101.400],
  ['TANJUNG PELEPAS', 1.367, 103.550],
  ['PENANG', 5.417, 100.350],
  ['LAEM CHABANG', 13.083, 100.883],
  ['BANGKOK', 13.700, 100.567],
  ['HO CHI MINH', 10.750, 106.733],
  ['CAI MEP', 10.533, 107.033],
  ['HAIPHONG', 20.867, 106.683],
  ['TANJUNG PRIOK', -6.100, 106.883],
  ['JAKARTA', -6.100, 106.883],
  ['SURABAYA', -7.200, 112.733],
  ['BATAM', 1.100, 104.000],
  ['MANILA', 14.600, 120.967],
  // Asia: East
  ['SHANGHAI', 31.233, 121.500],
  ['NINGBO', 29.867, 121.850],
  ['SHENZHEN', 22.550, 113.900],
  ['YANTIAN', 22.573, 114.267],
  ['SHEKOU', 22.470, 113.900],
  ['HONG KONG', 22.317, 114.117],
  ['NANSHA', 22.733, 113.617],
  ['GUANGZHOU', 23.100, 113.433],
  ['QINGDAO', 36.067, 120.317],
  ['XINGANG', 38.983, 117.783],
  ['TIANJIN', 38.983, 117.783],
  ['DALIAN', 38.933, 121.650],
  ['XIAMEN', 24.467, 118.067],
  ['FUZHOU', 26.083, 119.300],
  ['LIANYUNGANG', 34.750, 119.450],
  ['BUSAN', 35.100, 129.040],
  ['INCHEON', 37.450, 126.600],
  ['GWANGYANG', 34.900, 127.700],
  ['TOKYO', 35.633, 139.783],
  ['YOKOHAMA', 35.450, 139.650],
  ['NAGOYA', 35.083, 136.867],
  ['KOBE', 34.683, 135.200],
  ['OSAKA', 34.650, 135.433],
  ['HAKATA', 33.600, 130.400],
  ['KAOHSIUNG', 22.617, 120.283],
  ['KEELUNG', 25.133, 121.733],
  ['TAICHUNG', 24.283, 120.517],
  ['VLADIVOSTOK', 43.117, 131.900],
  // Oceania
  ['SYDNEY', -33.967, 151.217],
  ['MELBOURNE', -37.833, 144.917],
  ['BRISBANE', -27.383, 153.167],
  ['FREMANTLE', -32.050, 115.750],
  ['ADELAIDE', -34.783, 138.500],
  ['AUCKLAND', -36.833, 174.783],
  ['TAURANGA', -37.650, 176.183],
  ['LYTTELTON', -43.600, 172.717],
  // --- Names seen only in the dev dataset (bloom-lake-dev), which carries the
  // wider worldwide lanes. Ambiguous ones were settled by reading the last
  // sea-leg endpoint on the live rows rather than guessing a country.
  // Pacific Mexico, confirmed across 16 rows (endpoint 17.98, -103.40).
  // Panama's Manzanillo would need a UN/LOCODE to tell apart.
  ['MANZANILLO', 19.053, -104.315],
  // Costa Rica, confirmed (endpoint 9.20, -84.90). Chile's Caldera is a
  // different port and still needs a locode; bare CALDERA stays absent.
  ['PUERTO CALDERA', 9.916, -84.722],
  ['PUERTO CORTES', 15.833, -87.950],
  ['RIO HAINA', 18.417, -70.017],
  ['LA GUAIRA', 10.600, -66.933],
  ['ORANJESTAD', 12.520, -70.035],
  ['POINTE A PITRE', 16.233, -61.533],
  ['FORT DE FRANCE', 14.600, -61.067],
  // Cartagena's container terminal, confirmed (endpoint 10.37, -75.52).
  ['CONTECAR', 10.374, -75.524],
  // Balboa side, confirmed (endpoint 8.99, -79.59).
  ['PANAMA CITY', 8.950, -79.566],
  ['CHANCAY', -11.570, -77.270],
  ['MALAGA', 36.717, -4.417],
  ['VIGO', 42.240, -8.722],
  ['CIVITAVECCHIA', 42.094, 11.787],
  ['FOS SUR MER', 43.405, 4.885],
  ['DOVER', 51.126, 1.325],
  ['OSLO', 59.903, 10.747],
  ['STOCKHOLM', 59.325, 18.100],
  ['YANTAI', 37.552, 121.391],
  // Observed discharge node for "TAIPEI" rows (25.18, 121.75) — the Keelung /
  // Taipei Port roads, not the inland city centre.
  ['TAIPEI', 25.177, 121.746],
  // Deliberately absent: FREEPORT (Bahamas vs Texas) and bare CALDERA (Chile
  // vs Costa Rica). Two real ports share each name with no live geometry to
  // settle it, so a guess would draw a confidently wrong pin.
];

/**
 * English-language variants portNames.js does not cover. It already maps the
 * Spanish source spellings (FILADELFIA, SHANGAI, PUSAN, TOKIO...) to English
 * before the payload reaches the map, so only English legacy/alternate names
 * belong here. Values must exist in PORT_COORDS.
 */
const PORT_ALIASES = {
  JNPT: 'NHAVA SHEVA',
  'JAWAHARLAL NEHRU': 'NHAVA SHEVA',
  MADRAS: 'CHENNAI',
  KOCHI: 'COCHIN',
  SAIGON: 'HO CHI MINH',
  LEGHORN: 'LIVORNO',
  'VADO LIGURE': 'VADO',
  CHILUNG: 'KEELUNG',
  'PORT BOTANY': 'SYDNEY',
  'PORT KELANG': 'PORT KLANG',
};

const PORT_BY_NAME = new Map(PORT_COORDS.map(([name, lat, lng]) => [name, [lat, lng]]));

const BY_LENGTH = [...PORT_COORDS].sort((a, b) => b[0].length - a[0].length);

/**
 * Accent fold. The A-Z strip below turns every accented letter into a space,
 * so without this "PTO LIMÓN" degrades to "PTO LIM N" and never resolves.
 */
const ACCENT_FOLD = {
  Á: 'A', À: 'A', Ä: 'A', Â: 'A', Ã: 'A', Å: 'A',
  É: 'E', È: 'E', Ë: 'E', Ê: 'E',
  Í: 'I', Ì: 'I', Ï: 'I', Î: 'I',
  Ó: 'O', Ò: 'O', Ö: 'O', Ô: 'O', Õ: 'O',
  Ú: 'U', Ù: 'U', Ü: 'U', Û: 'U',
  Ñ: 'N', Ç: 'C',
};

function normalizePort(port) {
  return String(port || '')
    .toUpperCase()
    .replace(/[ÁÀÄÂÃÅÉÈËÊÍÌÏÎÓÒÖÔÕÚÙÜÛÑÇ]/g, (ch) => ACCENT_FOLD[ch] || ch)
    .replace(/[^A-Z ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const num = (v) => (v == null || v === '' ? NaN : Number(v));
const validLatLng = (lat, lng) =>
  Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;

function coordFromStop(stop) {
  const lat = num(stop?.latitude ?? stop?.lat ?? stop?.arrival_lat ?? stop?.port_lat);
  const lng = num(stop?.longitude ?? stop?.lng ?? stop?.lon ?? stop?.arrival_lng ?? stop?.port_lng ?? stop?.port_lon);
  return validLatLng(lat, lng) ? [lat, lng] : null;
}

/**
 * Whole-word phrase containment. A worldwide table makes bare substring tests
 * unsafe — "TEMA" sits inside "GUATEMALA", "VADO" inside "VADODARA" — so a
 * table name only counts when it occupies whole words.
 */
function containsPhrase(haystack, needle) {
  return ` ${haystack} `.includes(` ${needle} `);
}

/**
 * Expand the "PTO" abbreviation, then drop decorations carriers add
 * ("PORT OF X"). Never strips a bare "PORT " — that would break PORT SAID.
 */
function portKey(port) {
  return normalizePort(port)
    .replace(/^PTO\b/, 'PUERTO')
    .replace(/^(?:PORT OF|PUERTO DE|PUERTO DEL|PORTO DI)\s+/, '');
}

export function resolvePortLatLng(port, stop) {
  const fromStop = coordFromStop(stop);
  if (fromStop) return fromStop;
  const p = portKey(port);
  if (!p) return null;
  const exact = PORT_BY_NAME.get(p);
  if (exact) return exact;
  const aliased = PORT_ALIASES[p] && PORT_BY_NAME.get(PORT_ALIASES[p]);
  if (aliased) return aliased;
  // Feed name carries the port plus decoration ("PORT HUENEME" -> "HUENEME").
  // Longest table name first, so "SAN ANTONIO" never resolves via a shorter entry.
  const hit = BY_LENGTH.find(([name]) => containsPhrase(p, name));
  if (hit) return [hit[1], hit[2]];
  // Feed name is a shorter form ("SPEZIA" -> "LA SPEZIA"). Only trust it when
  // exactly one port contains it, so a stub like "PORT" or "SAN" stays null
  // instead of silently landing on an arbitrary port.
  const partial = PORT_COORDS.filter(([name]) => containsPhrase(name, p));
  return partial.length === 1 ? [partial[0][1], partial[0][2]] : null;
}

function isSamePortName(port, name) {
  const p = normalizePort(port).replace(/^PORT OF |^PORT /, '');
  const n = String(name || '').toUpperCase();
  return Boolean(p && n && (p === n || p.includes(n) || n.includes(p)));
}

/** AIS fix from the row only (no POD fallback). */
export function rowLatLng(row) {
  const lat = num(row?.latitude);
  const lng = num(row?.longitude);
  return validLatLng(lat, lng) ? [lat, lng] : null;
}

/**
 * Pin: remaining (not at_port/discharged) AIS if present, else row AIS.
 * Never from route_geojson CURRENT (RAILWAY / searoute canal node).
 */
export function shipmentPinLatLng(shipment) {
  const groups = Array.isArray(shipment?.tracked_groups) ? shipment.tracked_groups : [];
  for (const g of groups) {
    if (cargoIsDischarged(g)) continue;
    const pin = rowLatLng(g);
    if (pin) return pin;
  }
  // Every group is discharged (or there are none). The cargo is off the ship,
  // so pin the discharge port: the row's lat/lng keeps tracking the vessel,
  // which sails on — Savannah cargo was showing at Port Hueneme, and Asian
  // PODs half a world away. Pass no stop here, or coordFromStop would read
  // the shipment's own lat/lng and hand back that same vessel position.
  if (cargoIsDischarged(shipment)) {
    return resolvePortLatLng(shipment?.arrival_port) || rowLatLng(shipment);
  }
  return rowLatLng(shipment) || resolvePortLatLng(shipment?.arrival_port, shipment);
}

export function samePortName(a, b) {
  const x = normalizePort(a).replace(/^PORT OF |^PORT /, '');
  const y = normalizePort(b).replace(/^PORT OF |^PORT /, '');
  return Boolean(x && y && (x === y || x.includes(y) || y.includes(x)));
}

export function pinStackKey(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return `${lat.toFixed(3)},${lng.toFixed(3)}`;
}

function nudgePinKm(pin, km, angleRad = Math.PI / 4) {
  if (!pin) return pin;
  const dLat = (km / 111.32) * Math.cos(angleRad);
  const cosLat = Math.max(0.2, Math.cos((pin[0] * Math.PI) / 180));
  const dLng = (km / (111.32 * cosLat)) * Math.sin(angleRad);
  return [pin[0] + dLat, pin[1] + dLng];
}

export function haversineKm(a, b) {
  if (!a || !b) return Infinity;
  const R = 6371;
  const dLat = ((b[0] - a[0]) * Math.PI) / 180;
  const dLon = ((b[1] - a[1]) * Math.PI) / 180;
  const x =
    Math.sin(dLat / 2) ** 2
    + Math.cos((a[0] * Math.PI) / 180) * Math.cos((b[0] * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}


/** Extra gap when a delayed stack sits on top of a nearby blue pin. */
export function offsetDelayedFromNeighbors(pin, neighborPins, minKm = 12, pushKm = 16) {
  if (!pin) return pin;
  const close = (neighborPins || []).some((other) => other && haversineKm(pin, other) < minKm);
  return close ? nudgePinKm(pin, pushKm) : pin;
}

